import SmoothScroll from "smooth-scroll";
import Splide from "@splidejs/splide";
import jquery from "jquery";
import lightbox from "lightbox2";

var scroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true,
});

lightbox.option({
  'resizeDuration': 300,
  'wrapAround': true,
  'positionFromTop': 80,
  'showImageNumberLabel': false,
});

resultsSlider();
function resultsSlider() {
  const slider = document.querySelector('.results__slider');
  const prevButton = document.querySelector('.results__slider__prev');
  const nextButton = document.querySelector('.results__slider__next');
  const splide = new Splide(slider, {
    type: "loop",
    perPage: 1,
    focus: "center",
    gap: "2.5rem",
    fixedWidth: "36.25rem",
    arrows: false,
    pagination: false,
    mediaQuery: "max",
    breakpoints: {
      840: {
        fixedWidth: '80%',
      }
    },
  });

  splide.mount();

  prevButton.addEventListener('click', () => { splide.go('<') });
  nextButton.addEventListener('click', () => { splide.go('>') });
}

voicesSlider();
function voicesSlider() {
  const slider = document.querySelector('.voices__slider');
  const prevButton = document.querySelector('.voices__slider__prev');
  const nextButton = document.querySelector('.voices__slider__next');
  const splide = new Splide(slider, {
    type: "loop",
    arrows: false,
    pagination: false,
    gap: '2.5rem',
    padding: '0.25rem',
    mediaQuery: "max",
  });

  splide.mount();

  prevButton.addEventListener('click', () => { splide.go('<') });
  nextButton.addEventListener('click', () => { splide.go('>') });
}
